/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Notificaciones recientes de la aplicación',
    titleMeta: 'Mostrando notificaciones recientes en la aplicación CamAPS FX',
    descriptionMeta: 'Aquí está el texto de las notificaciones recientes en la aplicación con respecto a las actualizaciones de la aplicación, avisos de seguridad, actualizaciones del manual del usuario',
    keywords: 'Notificaciones' ,
    localeMeta: 'es_es',

    heading: 'Notificaciones recientes de la aplicación',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Actualización de la aplicación de Android (YpsoPump only) 28/10/2026',
    body_132:'Estimado usuario de CamAPS FX, una nueva versión de la aplicación 1.4(195) estará disponible en los próximos días. Por favor, elija su momento preferido para la actualización desactivando la actualización automática para CamAPS FX en Google Play Store. Si tiene alguna pregunta, comuníquese con el servicio al cliente de mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Actualización necesaria (solo YpsoPump) 20/10/2026',
    body_130:'¡Actualización necesaria! Esta versión de CamAPS FX puede bloquearse y reiniciarse con mayor frecuencia. Actualice a la última versión AHORA a través de Google Play Store. La versión 1.4(190) de la aplicación dejará de estar disponible el 20/11/2026. Después de esta fecha, “Auto Mode” dejará de estar disponible hasta que se actualice la aplicación. La administración de insulina a través de la bomba continuará.',

    header_129:'',
    body_129:'',

    header_128:'Actualización del manual de usuario (solo YpsoPump) 15/10/2026',
    body_128:'Ya está disponible una versión actualizada del manual de usuario. Puede acceder a ella desde el menú principal de CamAPS FX seleccionando Ayuda después de actualizar a la versión más reciente de la aplicación.',

    header_127:'',
    body_127:'',

    header_126:'Actualización de la aplicación de Android (YpsoPump only) 02/10/2026',
    body_126:'Estimado usuario de CamAPS FX, una nueva versión de la aplicación 1.4(194) estará disponible en los próximos días. Por favor, elija su momento preferido para la actualización desactivando la actualización automática para CamAPS FX en Google Play Store. Si tiene alguna pregunta, comuníquese con el servicio al cliente de mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'Actualización de la app de iOS (YpsoPump only) 28/09/2026',
    body_122:'Estimado usuario de CamAPS FX, una NUEVA VERSIÓN de la aplicación 1.4(196) estará disponible en los próximos días. DESACTIVA las ACTUALIZACIONES AUTOMÁTICAS de CamAPS FX en la App Store para seleccionar tu momento preferido de actualización. Si tienes alguna pregunta, por favor contacta con el Servicio de Atención al Cliente de mylife-Diabetescare.',

    header_121:'Lanzamiento de Apple iOS 27 11/09/2026',
    body_121:'Apple lanzará pronto iOS 27. Para garantizar el uso ininterrumpido de la aplicación CamAPS FX, consulte el sitio web del fabricante del sensor para verificar la compatibilidad del teléfono inteligente y del sistema operativo ANTES de actualizar su iPhone a iOS 27. Las actualizaciones automáticas pueden estar ACTIVADAS de forma predeterminada en la configuración de su teléfono; considere DESACTIVARLAS.',

    header_120:'',
    body_120:'',

    header_119:'Actualización del manual de usuario (solo YpsoPump) 10/09/2026',
    body_119:'Ya está disponible una versión actualizada del manual de usuario. Puede acceder a ella desde el menú principal de CamAPS FX seleccionando Ayuda después de actualizar a la versión más reciente de la aplicación.',

    header_118:'Actualización de la aplicación de Android (YpsoPump only) 07/09/2026',
    body_118:'Estimado usuario de CamAPS FX, una nueva versión de la aplicación 1.4(193) estará disponible en los próximos días. Por favor, elija su momento preferido para la actualización desactivando la actualización automática para CamAPS FX en Google Play Store. Si tiene alguna pregunta, comuníquese con el servicio al cliente de mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Desactivación de versiones de Android inferiores a 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Estimado usuario de CamAPS FX, por razones de ciberseguridad, las versiones INFERIORES a 1.4(192) se SUSPENDERÁN el 31/08/2026. Asegúrese de que su aplicación esté ACTUALIZADA a la versión 1.4(192) antes de esta fecha. Si tiene alguna pregunta, contacte con el servicio de atención al cliente de mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Lanzamiento de Android OS 17 24/06/2026',
    body_109:'Android lanzará próximamente OS 17. Para garantizar el uso ininterrumpido de la aplicación CamAPS FX, consulte el sitio web del fabricante del sensor para verificar la compatibilidad del teléfono inteligente y del sistema operativo ANTES de actualizar su Android a OS 17. Las actualizaciones automáticas pueden estar ACTIVADAS de forma predeterminada en la configuración de su teléfono; DESACTÍVELAS.',

    header_108:'Dexcom G7 está disponible (solo Ypsopump) 23/06/2026',
    body_108:'¡La integración del sistema CGM Dexcom G7 ya está disponible! Los usuarios que cambien de Dexcom G6 pueden encontrar en nuestro sitio web una guía de cambio, información para la resolución de problemas y una descripción general de los sistemas CGM compatibles: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Actualización del manual de usuario (solo YpsoPump) 22/06/2026',
    body_106:'Ya está disponible una versión actualizada del manual de usuario. Puede acceder a ella desde el menú principal de CamAPS FX seleccionando Ayuda.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Actualización de la aplicación de Android (YpsoPump only) 12/06/2026',
    body_103:'Estimado usuario de mylife CamAPS FX, una nueva versión de la aplicación 1.4(192) estará disponible en los próximos días. Por favor, elija su momento preferido para la actualización desactivando la actualización automática para CamAPS FX en Google Play Store. Si tiene alguna pregunta, comuníquese con el servicio al cliente de mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Fin de los sistemas operativos antiguos 22/05/2026',
    body_98:'Mientras preparamos la próxima actualización de la aplicación, tenga en cuenta que CamAPS FX sólo será compatible con teléfonos con OS 13 o superior o iOS 18 o superior. Después de esta versión, los usuarios con teléfonos con versiones inferiores a OS 13 o iOS 18 no podrán actualizar ni reinstalar CamAPS FX.',

    header_97:'Actualización de la aplicación iOS 22/05/2026',
    body_97:'Estimado usuario de CamAPS FX, una nueva versión de CamAPS FX, 1.4(195), estará disponible en los próximos días. Para elegir cuándo actualizar, desactive las ACTUALIZACIONES AUTOMÁTICAS en la App Store. Los usuarios con versiones inferiores a iOS 18 no podrán actualizar CamAPS FX a esta versión. Ya está disponible una versión actualizada del manual de usuario. Para cualquier consulta, póngase en contacto con el servicio de atención al cliente de mylife-Diabetescare.',

    header_96:'',
    body_96:'',

    header_95:'Actualización de Dexcom G7 (solo Ypsopump) 06/05/2026',
    body_95:'Nos estamos acercando. La compatibilidad del sistema CGM Dexcom G7 con mylife CamAPS FX estará disponible para el verano de 2026. Le mantendremos informado a medida que se acerque el lanzamiento.',

    header_94:'',
    body_94:'',

    header_93:'Desactivación de versiones de iOS inferiores a 1.4(193) (solo Ypsopump) 22/04/2026',
    body_93:'Estimado usuario de CamAPS FX, por razones de ciberseguridad, las VERSIONES INFERIORES a 1.4(193) se DESCONTINUARÁN el 30 de abril. Asegúrese de que su aplicación esté ACTUALIZADA a la versión 1.4(193) antes de esta fecha. Si tiene alguna pregunta, póngase en contacto con el Servicio de Atención al Cliente de mylife-Diabetescare.',

    header_92:'Retirada gradual de los sistemas operativos antiguos 21/04/2026',
    body_92:'Por razones de ciberseguridad, a partir del 30 de junio de 2026, mylife CamAPS FX SOLO será compatible con teléfonos compatibles con el sensor que ejecuten los siguientes sistemas operativos: Android OS 13 o superior y Apple iOS 18 o superior. Los usuarios con sistemas operativos INFERIORES a Android OS 13 o Apple iOS 18 NO podrán ACTUALIZAR ni REINSTALAR mylife CamAPS FX después de esta fecha.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'Desactivación de versiones de iOS inferiores a 1.4(193) (solo Ypsopump) 16/03/2026',
    body_87:'Estimado usuario de CamAPS FX, por razones de ciberseguridad, las VERSIONES INFERIORES a 1.4(193) se DESCONTINUARÁN el 31 de marzo. Asegúrese de que su aplicación esté ACTUALIZADA a la versión 1.4(193) antes de esta fecha. Si tiene alguna pregunta, póngase en contacto con el Servicio de Atención al Cliente de mylife-Diabetescare.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Actualización de la aplicación Android (solo Ypsopump) 02/02/2026',
    body_82:'Estimado usuario de CamAPS FX, en los próximos días estará disponible una NUEVA VERSIÓN de la aplicación – 1.4(190). DESACTIVE LAS ACTUALIZACIONES AUTOMÁTICAS de CamAPS FX en Google Play Store para poder seleccionar el momento de actualización que prefiera. Por motivos de ciberseguridad, las VERSIONES INFERIORES a 1.4(190) se DESCONTINUARÁN el 31 de marzo. Si tiene alguna pregunta, póngase en contacto con el Servicio de Atención al Cliente de mylife-Diabetescare.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Mensaje de mylife-Diabetescare (solo YpsoPump) 17/12/2025',
    body_77:'Es importante que a partir de hoy rellene sus mylife YpsoPump Reservorios conforme al procedimiento descrito en nuestras guías, para poder asegurar la continuidad de su tratamiento. Gracias por su colaboración.',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Mensaje de mylife-Diabetescare (solo YpsoPump) 09/12/2025',
    body_74:'Puedes rellenar tu depósito mylife YpsoPump una vez, dentro de los 7 días posteriores al primer llenado. Obtén más información en la página del Depósito del sitio web de mylife-diabetescare.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Información importante de seguridad sobre su sensor del sistema FreeStyle Libre 3 25/11/2025',
    body_70:'Abbott ha identificado que algunos sensores FreeStyle Libre 3 y FreeStyle Libre 3 Plus pueden mostrar lecturas de glucosa falsamente bajas. Vaya a',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' para comprobar si su(s) sensor(es) actual(es) o sin usar están afectados. Si las lecturas del sensor no coinciden con sus síntomas o expectativas, desactive el modo Auto y use un medidor de glucosa en sangre para tomar decisiones de tratamiento. Si tiene preguntas o necesita informar cualquier problema con su sensor del sistema FreeStyle Libre 3, comuníquese con el Servicio de Atención al Cliente de Abbott en 910 478 901. El número de serie de su sensor actual se encuentra en el menú de la aplicación, en la sección Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'Actualización de la aplicación iOS (solo YpsoPump) 25/11/2025',
    body_69:'Estimado usuario de mylife CamAPS FX, una NUEVA VERSIÓN de la aplicación estará disponible en los próximos días. DESACTIVA las ACTUALIZACIONES AUTOMÁTICAS de CamAPS FX en la App Store para seleccionar tu hora de actualización preferida. Tu versión actual será DESCONTINUADA el 9 de diciembre de 2025. Si tienes alguna pregunta, por favor contacta al Servicio al Cliente de Ypsomed.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'AVISO DE SEGURIDAD SOBRE 28/10/2025',
    body_62:'Por favor lea del aviso importante',
    body_62_link_text:'N-0125',
    body_62_end: '. Ir al menú de la aplicación -> Avisos de seguridad.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+ES+final.pdf',

    header_61:'Actualización de la app de iOS (solo YpsoPump) 02/10/2025',
    body_61:'Para un rendimiento óptimo de la app, por favor ACTUALIZA tu mylife CamAPS FX a la ÚLTIMA VERSIÓN (1.4(192)) a través de la App Store de Apple.',

    header_60:'',
    body_60:'',

    header_59:'Actualización de la app de iOS (solo YpsoPump) 22/09/2025',
    body_59:'Estimado usuario de mylife CamAPS FX, una NUEVA VERSIÓN de la aplicación estará disponible en los próximos días. DESACTIVA las ACTUALIZACIONES AUTOMÁTICAS de CamAPS FX en la App Store para seleccionar tu momento preferido de actualización. Una nueva versión del manual del usuario estará disponible. Si tienes alguna pregunta, por favor contacta con el Servicio de Atención al Cliente de Ypsomed.',

    header_58:'Lanzamiento de iOS 26 (solo YpsoPump) 13/09/2025',
    body_58:'Apple lanzará pronto iOS 26. Para garantizar un uso ininterrumpido de la aplicación mylife CamAPS FX, por favor verifica en el sitio web del fabricante del sensor la compatibilidad de tu smartphone y sistema operativo antes de actualizar tu iPhone a iOS 26. Nota: Es posible que las actualizaciones automáticas estén activadas en la configuración de tu teléfono por defecto, por favor desactívalas.',

    header_57:'Actualización de la aplicación de Android (solo YpsoPump) 26/08/2025',
    body_57:'Estimado usuario de mylife CamAPS FX, una nueva versión de la aplicación estará disponible en los próximos 2 a 3 días. Por favor, elija su momento preferido para la actualización desactivando la actualización automática para CamAPS FX en Google Play Store. Una nueva versión del manual del usuario estará disponible. Si tiene alguna pregunta, comuníquese con el servicio al cliente de Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Interrupción de versiones antiguas de la aplicación 01/07/2025',
    body_49:'Por favor, actualice su aplicación a la versión más reciente disponible en Google Play. La versión actual dejará de funcionar el 1 de agosto de 2025.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Por razones de ciberseguridad, a partir del 1 de agosto de 2025, mylife CamAPS FX solo será compatible con teléfonos compatibles con sensores que ejecuten sistemas operativos Android 12 y superiores. Los usuarios de sistemas operativos por debajo de OS 12, ya no podrán actualizar o reinstalar mylife CamAPS FX después de esta fecha.',

    header_47:'Versión iOS (sólo YpsoPump) 09/06/2025',
    body_47:'¡La aplicación mylife CamAPS FX ya está disponible para iPhone! Si está pensando en cambiar a iOS, visite la sección « Información importante para usuarios de iOS » en www.mylife-diabetescare.com/es-ES/mylife-loop.html.',

    header_46:'',
    body_46:'',

    header_45:'Sistema operativo Android 16 09/06/2025',
    body_45:'Para asegurar el uso ininterrumpido de la aplicación mylife CamAPS FX, por favor verifica en el sitio web del fabricante del sensor para verificar la compatibilidad antes de actualizar a Android OS 16. Nota: Las actualizaciones automáticas podrían estar activadas por defecto en la configuración de tu teléfono.',

    header_44:'Actualización del manual de usuario 20/05/2025',
    body_44:'Existe una versión actualizada del manual de usuario.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Nueva actualización (18/03/2025)',
    body_40:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 48 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Descontinuación de la versión antigua de la aplicación (solo Ypsopump)',
    body_37:'Por favor, actualice su aplicación a la última versión disponible en Google Play. La versión actual dejará de funcionar el 7 de febrero de 2025.',

    header_36:'Actualización de la aplicación 06/01/2025',
    body_36:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 48 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Por razones de ciberseguridad, a partir del 1 de enero de 2025, mylife CamAPS FX solo será compatible con teléfonos compatibles con sensores que ejecuten sistemas operativos Android 10 y superiores. Los usuarios de sistemas operativos por debajo de OS 10, ya no podrán actualizar o reinstalar mylife CamAPS FX después de esta fecha. Recordatorio, el sistema aún no es compatible con OS15',
	
	header_34:'',
    body_34:'',
	
	header_33:'Avviso di Manutenzione Programmata 05/12/2024',
    body_33:'Debido al mantenimiento programado de la nube del servicio CamAPS FX, la funcionalidad Companion no estará disponible el 7 de diciembre a partir de las 10:00 GMT durante aproximadamente tres horas. Pedimos disculpas por cualquier inconveniente que esto pueda causar..',
	
	header_32:'Actualización del manual de usuario 28/11/2024',
    body_32:'Existe una versión actualizada del manual de usuario.',
	
	header_31:'Actualización de la aplicación 17/11/2024',
    body_31:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 48 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Por razones de ciberseguridad, a partir del 1 de enero de 2025, mylife CamAPS FX solo será compatible con teléfonos compatibles con sensores que ejecuten sistemas operativos Android 10 y superiores. Los usuarios de sistemas operativos por debajo de OS 10, ya no podrán actualizar o reinstalar mylife CamAPS FX después de esta fecha',
	
	header_29:'Actualización de la aplicación 09/10/2024',
    body_29:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 48 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Por razones de ciberseguridad, a partir del 1 de enero de 2025, mylife CamAPS FX solo será compatible con teléfonos compatibles con sensores que ejecuten sistemas operativos Android 10 y superiores. Los usuarios de sistemas operativos por debajo de OS 10, ya no podrán actualizar o reinstalar mylife CamAPS FX después de esta fecha',
	
	header_27:'',
    body_27:'',
	
	header_26:'Actualización del manual de usuario 11/05/2024',
    body_26:'Existe una versión actualizada del manual de usuario.',
	
	header_25:'Actualización de la aplicación 05/05/2024',
    body_25:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 24 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',
	
	header_24:'',
    body_24:'',
	
	header_23:'Actualización de la aplicación 24/04/2024',
    body_23:'Estimado usuario de mylife CamAPS FX, Una nueva versión de la aplicación estará lista en las próximas 24 horas. Para elegir tu hora preferida para la actualización, desactiva la actualización automática para CamAPS FX en la Google Play Store. Si tienes alguna pregunta, por favor contacta al servicio al cliente de Ypsomed.',
	
	header_22:'Actualización del manual de usuario 21/04/2024',
    body_22:'Existe una versión actualizada del manual de usuario.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Actualización del manual de usuario 04/03/2024',
    body_16:'Existe una versión actualizada del manual de usuario.',
	
	header_15:'Actualización del manual de usuario 04/01/2024',
    body_15:'Existe una versión actualizada del manual de usuario.',
	
	header_14:' 22/11/2023',
    body_14:'Recordatorio: Para asegurar el uso ininterrumpido de la aplicación mylife CamAPS FX, por favor verifica en el sitio web del fabricante del sensor para verificar la compatibilidad antes de actualizar a Android OS 14. Nota: Las actualizaciones automáticas podrían estar activadas por defecto en la configuración de tu teléfono.de actualizar a Android OS 14.',
	
	header_13:'AVISO DE SEGURIDAD 14/11/2023',
    body_13:'AVISO DE SEGURIDAD SOBRE',
    body_13_link_text:'Por favor lea del aviso importante',
    body_13_end: '. Ir al menú de la aplicación -> Avisos de seguridad.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users_ES_final+v2.pdf',

	header_12:'Actualización del manual de usuario 10/11/2023',
    body_12:'Existe una versión actualizada del manual de usuario.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'Para asegurar el uso ininterrumpido de la aplicación mylife CamAPS FX, por favor verifica en el sitio web del fabricante del sensor para verificar la compatibilidad antes de actualizar a Android OS 14. Nota: Las actualizaciones automáticas podrían estar activadas por defecto en la configuración de tu teléfono.Por favor, asegúrate de que estás ejecutando la aplicación mylife CamAPS FX versión 1.4(173) antes de actualizar a Android OS 14.',
	
	header_10:'AVISO DE SEGURIDAD 15/08/2023',
    body_10:'AVISO DE SEGURIDAD SOBRE Por favor lea del aviso importante. Ir al menú de la aplicación -> Avisos de seguridad.',
	
	header_9:'Actualización del manual de usuario 27/07/2023',
    body_9:'Existe una versión actualizada del manual de usuario.',
	
	header_8:'Compatibilidad de Glooko 21/07/2023',
    body_8:'Diasend se suspenderá el 28 de julio. Si desea seguir compartiendo sus datos con su equipo de diabetes, actualice su cuenta de Diasend a Glooko o cree una nueva cuenta de Glooko. Actualice a la última versión de mylife CamAPS FX, ingrese su nuevo nombre de usuario y contraseña de Glooko en el menú de compartir y reinicie su teléfono inteligente. Diasend seguirá disponible para ver los datos históricos durante el resto del año.',
	
	header_7:'Samsung A-Series 14/07/2023 ',
    body_7:'Los usuarios de los modelos Samsung A-Series (es decir, A53, A33) pueden haber experimentado pérdida de señal en su sensor CGM después de la última actualización de Samsung One UI 5.1. Samsung ha identificado el problema y se encuentra desarrollando una solución. Samsung planea lanzar una actualización de One UI el 24 de julio (según tu región), la cual resolverá el problema de pérdida de señal. Se recomienda instalar la actualización tan pronto como esté disponible. Si aún no has actualizado a One UI 5.1, te recomendamos esperar la próxima actualización Samsung One UI.',

    header_6:'Compatibilidad de Glooko 08/06/2023 ',
    body_6:'mylife CamAPS FX ahora es compatible con Glooko. Por favor, actualiza tu aplicación mylife CamAPS FX a la versión 1.4(172). Si estás compartiendo datos con una clínica, recibirás una notificación dentro de tu cuenta existente de diasend cuando tu clínica se actualice a Glooko. Una vez completado, ingresa tu nuevo nombre de usuario y contraseña de Glooko en el menú de compartir y reinicia tu smartphone. Por favor, actualiza a Glooko antes del 28 de julio de 2023. diasend estará disponible para ver datos históricos durante el resto del año.',

    header_5:'',
    body_5:'',

    header_4:'Actualización del manual de usuario 27/05/2023',
    body_4:'Existe una versión actualizada del manual de usuario.',

    header_3:'Alertas SMS (Sólo Ypsopump) 11/05/2023',
    body_3:'Con la próxima actualización 1.4(171) a mediados de mayo, podrás tener hasta 5 seguidores de SMS activos Y utilizar el modo Companion al mismo tiempo. Para utilizar el modo Companion, el teléfono del usuario debe tener una conexión a Internet para compartir datos. Los usuarios deben tener una tarjeta SIM para permitir el envío de SMS desde su teléfono. Si estás utilizando una de estas opciones, te recomendamos que compruebes que tu plan móvil incluya la cobertura de SMS y/o datos dependiendo de la opción que estés utilizando.',

    header_2:'Ciberseguridad (Sólo Ypsopump) 24/04/2023',
    body_2:'La seguridad de la aplicación mylife CamAPS FX es de suma importancia. A partir de mediados de mayo, habrá una actualización de ciberseguridad impuesta por Google Play Store. Tras esta actualización, es posible que un pequeño porcentaje de teléfonos no superen la comprobación de integridad de ciberseguridad. Puedes probar tu teléfono de antemano visitando el menú de ayuda y completando la comprobación. Si el teléfono no supera esta comprobación, prueba a desinstalar y volver a instalar la aplicación.',

    header_1:'',
    body_1:'',
};
